import { Link, useMatches } from 'react-router-dom';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/solid';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { CrumpType } from '@wajeez-web/core/types';
import { useCommonSelector } from '@wajeez-web/stores/common';

function Breadcrumbs() {
  const dir = useCommonSelector((s) => s.common.settings.dir);
  const matches = useMatches();
  const crumbs = matches
    // first get rid of any matches that don't have handle and crumb
    .filter((match) => Boolean((match.handle as any)?.crumb))
    // now map them into an array of elements, passing the loader
    // data to each one
    .map((match) => {
      const Crump = (match.handle as any)?.crumb as CrumpType;

      return typeof Crump === 'string'
        ? {
            title: (
              <ReturnTranslatedText
                text={`breadCrumbs.${Crump}`}
                origintext={Crump}
              />
            ),
            link: match.pathname,
          }
        : {
            title: (
              <Crump
                params={match.data as { [key: string]: string | undefined }}
                pathname={match.pathname as string}
              />
            ),
            link: match.pathname,
          };
    });

  return (
    <div className="hidden sm:flex flex-wrap items-center font-medium">
      {crumbs.map((item, i) =>
        i === 0 ? (
          <div key={`link ${item.link}`}>
            <Link
              to={item.link || '#'}
              className="whitespace-nowrap text-primary"
            >
              {item.title}
              {/* <ReturnTranslatedText
                text={`breadCrumbs.${item.title}`}
                origintext={item.title}
              /> */}
            </Link>
          </div>
        ) : (
          <div
            className="flex items-center ms-1 whitespace-nowrap"
            key={`link ${item.link}`}
          >
            {dir === 'ltr' ? (
              <ChevronRightIcon className="text-textSecondary h-5 w-5" />
            ) : (
              <ChevronLeftIcon className="text-textSecondary h-5 w-5" />
            )}
            <Link to={item.link || '#'} className=" text-primary ms-1 ">
              {item.title}
              {/* <ReturnTranslatedText
                text={`breadCrumbs.${item.title}`}
                origintext={item.title}
              /> */}
            </Link>
          </div>
        )
      )}
    </div>
  );
}

export default Breadcrumbs;
